import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FullValidationErrorFragment } from '@common/graphql/fragments';
import { gql, useMutation, useNavigate } from '@common/hooks';
import { Modal } from '@common/components';
import { mutationResponseMessage } from 'works/legacy/lib/message-helper';

const ARCHIVE_WORKS_LIST_TEMPLATE_MUTATION = gql`
  mutation archiveWorksListTemplateMutation($id: ID!) {
    archiveWorksListTemplate(id: $id) {
      worksListTemplate {
        id
      }

      errors {
        ...FullValidationErrorFragment
      }
    }
  }
  ${FullValidationErrorFragment}
`;

const ArchiveList = ({ worksListTemplate }) => {
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  const [archiveWorksListTemplate, { loading: mutationLoading }] = useMutation(
    ARCHIVE_WORKS_LIST_TEMPLATE_MUTATION,
    {
      refetchQueries: ['WorksListTemplatesQuery'],
      variables: { id: worksListTemplate.id },
    }
  );

  if (!worksListTemplate.canArchive.value) {
    return <></>;
  }

  const handleArchiveConfirm = () => {
    if (!mutationLoading) {
      archiveWorksListTemplate({
        variables: {
          id: worksListTemplate.id,
        },
      }).then((response) => {
        mutationResponseMessage({
          gqlResponse: response,
          onSuccess: 'Compliance list successfully archived',
          errorMessage: 'Failed to archive compliance list',
        });

        setShowModal(false);
        navigate('/works/admin/templates/compliance-list');
      });
    }
  };

  return (
    <>
      <Modal
        title="Are you sure you want to archive this compliance template?"
        className="archive-compliance-list-item-modal"
        visible={showModal}
        okText="Confirm"
        onCancel={() => setShowModal(false)}
        onOk={handleArchiveConfirm}
      >
        <p>After archiving, this template will not be listed.</p>
        <p>
          Note: past assignments that used this compliance template would not be
          affected.
        </p>
      </Modal>
      <a
        className="archive-works-list-template-icon"
        onClick={() => setShowModal(true)}
      >
        <b>Archive</b>
      </a>
    </>
  );
};

ArchiveList.propTypes = {
  worksListTemplate: PropTypes.shape({
    id: PropTypes.string.isRequired,
    canArchive: PropTypes.shape({
      value: PropTypes.bool.isRequired,
    }).isRequired,
  }),
};

export default ArchiveList;
